export const SEO_CONSTANTS = {
  BASE_URL: 'https://kimeraware.com',
  TWITTER_HANDLE: '@kimeraware',
  DEFAULT_OG_IMAGE: '/favicon.png',
  SITE_NAME: 'KimeraWare',
} as const;

export const STRUCTURED_DATA = {
  ORGANIZATION: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'KimeraWare',
    url: 'https://kimeraware.com',
    logo: 'https://kimeraware.com/favicon.png',
    description:
      'Independent Latin American indie game studio creating surreal narrative games. Developers of experimental indie games and art games for PC and Steam.',
    sameAs: [
      'https://twitter.com/kimeraware',
      'https://www.youtube.com/@KimeraWare',
      'https://www.instagram.com/kimeraware/',
    ],
    foundingDate: '2026',
    founders: [
      {
        '@type': 'Person',
        name: 'KimeraWare Team',
      },
    ],
    location: [
      {
        '@type': 'Place',
        name: 'Mexico',
      },
      {
        '@type': 'Place',
        name: 'Colombia',
      },
      {
        '@type': 'Place',
        name: 'Peru',
      },
      {
        '@type': 'Place',
        name: 'Argentina',
      },
      {
        '@type': 'Place',
        name: 'Venezuela',
      },
      {
        '@type': 'Place',
        name: 'Chile',
      },
      {
        '@type': 'Place',
        name: 'España',
      },
      {
        '@type': 'Place',
        name: 'Ecuador',
      },
      {
        '@type': 'Place',
        name: 'Spain',
      },
      {
        '@type': 'Place',
        name: 'United States',
      },
      {
        '@type': 'Place',
        name: 'Canada',
      },
      {
        '@type': 'Place',
        name: 'England',
      },
    ],
  },
  VIDEO_GAMES: {
    CATERVA: {
      '@context': 'https://schema.org',
      '@type': 'VideoGame',
      name: 'Caterva: Outsider Dreams',
      description: 'A surreal narrative indie game experience from KimeraWare',
      genre: ['Indie', 'Narrative', 'Surreal', 'Adventure'],
      gamePlatform: ['PC', 'Steam'],
      applicationCategory: 'Game',
      operatingSystem: 'Windows, macOS, Linux',
      keywords:
        'indie game, narrative game, surreal game, experimental game, art game, PC game, Steam game, Latin American game',
      publisher: {
        '@type': 'Organization',
        name: 'KimeraWare',
      },
      author: {
        '@type': 'Organization',
        name: 'KimeraWare',
      },
      inLanguage: ['English', 'Spanish'],
    },
    SAN_MARTIN: {
      '@context': 'https://schema.org',
      '@type': 'VideoGame',
      name: 'El Milagro de San Martín / The Miracle of San Martín',
      alternateName: ['El Milagro de San Martín', 'The Miracle of San Martín'],
      description: 'A unique narrative gaming experience from Latin American indie developers',
      genre: ['Indie', 'Narrative', 'Surreal', 'Adventure'],
      gamePlatform: ['PC', 'Steam'],
      applicationCategory: 'Game',
      operatingSystem: 'Windows, macOS, Linux',
      keywords:
        'indie game, narrative game, surreal game, experimental game, art game, PC game, Steam game, Latin American game',
      publisher: {
        '@type': 'Organization',
        name: 'KimeraWare',
      },
      author: {
        '@type': 'Organization',
        name: 'KimeraWare',
      },
      inLanguage: ['English', 'Spanish'],
    },
  },
} as const;
